import React from 'react';

import { DesignSystemError } from '../../../design-system/types/FallbackFunction';
import { ErrorFallback } from '../ErrorFallback/ErrorFallback';

export function ReviewRatingFallback({ error }: { error: DesignSystemError }) {
    return <ErrorFallback componentName="ReviewRating" error={error} data={error.data} />;
}
